/**
 * InterviewLink → InterviewLinkDraft, in one place.
 *
 * Shared by the Interview Links page and the request card's link editor modal. A second copy would
 * drift the moment a field is added to the link: the two forms would then save different shapes,
 * and the difference would only show up as a quietly missing setting.
 */
import { emptyDraft, type InterviewLink, type InterviewLinkDraft } from '../../services/interviewLinksApi';

export function toDraft(link: InterviewLink): InterviewLinkDraft {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- destructured only to drop them
  const { id, createdAt, updatedAt, createdBy, roleClosed, ...rest } = link;
  return { ...emptyDraft(), ...rest };
}
